// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__Z_HGy","Root__standalone":"Badge_Root__standalone__2xsxH"};